import { isNumber } from 'lodash-es';

export default {
  computed: {
    primaryIconSize() {
      return (width, height) => {
        // This algorithm ensures it scales the icon based on the map's zoom level
        // Maximum zoomLevel is 22. This means that the maximum primary icon size will be 60x60 px.
        // Minimum zoomLevel is 9 => icon will be at half its size at minimum.
        const zoom = isNumber(this.zoomLevel) ? this.zoomLevel : this.zoom;
        const zoomLevel = zoom <= 9 ? 9 : zoom;
        const ratio = parseFloat(zoomLevel / 18);

        return {
          width: parseInt(width * ratio),
          height: parseInt(height * ratio),
        };
      };
    },
  },
};
